import { useConfigInit } from "@/hooks/useConfigInit";
import Router from "./routes";

function App() {
  useConfigInit();

  return (
    <>
      <Router />
    </>
  );
}

export default App;
